export const COMPANY_NAME = "KINETIC LOOPS LLC";
export const COMPANY_SHORT = "Kinetic Loops";
export const COMPANY_INITIALS = "KL";
export const COMPANY_ADDRESS_FULL = "29500 Mira Loma Dr, Temecula, California, US 92592-4216";
export const COMPANY_LOCATION = "Temecula, CA";
export const COMPANY_REGION = "Riverside County";
export const MAP_URL = "https://www.google.com/maps/search/?api=1&query=29500%20Mira%20Loma%20Dr%2C%20Temecula%2C%20California%2C%20US%2092592-4216";
export const ABOUT_IMAGE_URL = "https://images.unsplash.com/photo-1488521787991-ed7bbaae773c?auto=format&fit=crop&w=1600&q=80";

export const PROFILE_FACTS = [
  { "label": "Organization", "value": "Limited liability company" },
  { "label": "Region", "value": "Riverside County" },
  { "label": "Location", "value": "Temecula, CA" },
];

export const PUBLIC_INFO = [
  { "label": "Organization", "value": "KINETIC LOOPS LLC" },
  { "label": "City & State", "value": "Temecula, CA" },
  { "label": "Address", "value": "29500 Mira Loma Dr, Temecula, California, US 92592-4216" },
];

export const CARE_PILLARS = [
  { "icon": "◐", "title": "Public profile", "body": "A concise directory page centered on publicly available organization information." },
  { "icon": "✦", "title": "Local presence", "body": "Based in Temecula and presented with clear regional context for visitors." },
  { "icon": "◇", "title": "Clear details", "body": "Essential organization and location details are easy to scan on any device." },
  { "icon": "○", "title": "Simple directions", "body": "A direct map link makes it easy to locate the listed principal address." },
];
